// Synthesized drum voices for the drum machine.

function noiseBuffer(ctx, duration) {
  const len = Math.floor(ctx.sampleRate * duration);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
  return buf;
}

export function playKick(ctx, dest, time, gain = 1) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.frequency.setValueAtTime(150, time);
  osc.frequency.exponentialRampToValueAtTime(40, time + 0.15);
  g.gain.setValueAtTime(gain, time);
  g.gain.exponentialRampToValueAtTime(0.001, time + 0.4);
  osc.connect(g).connect(dest);
  osc.start(time);
  osc.stop(time + 0.45);
}

export function playSnare(ctx, dest, time, gain = 1) {
  const noise = ctx.createBufferSource();
  noise.buffer = noiseBuffer(ctx, 0.2);
  const nf = ctx.createBiquadFilter();
  nf.type = "highpass";
  nf.frequency.value = 1500;
  const ng = ctx.createGain();
  ng.gain.setValueAtTime(gain, time);
  ng.gain.exponentialRampToValueAtTime(0.001, time + 0.2);
  noise.connect(nf).connect(ng).connect(dest);

  const osc = ctx.createOscillator();
  osc.type = "triangle";
  osc.frequency.setValueAtTime(180, time);
  const og = ctx.createGain();
  og.gain.setValueAtTime(gain * 0.7, time);
  og.gain.exponentialRampToValueAtTime(0.001, time + 0.12);
  osc.connect(og).connect(dest);

  noise.start(time);
  noise.stop(time + 0.2);
  osc.start(time);
  osc.stop(time + 0.12);
}

function hat(ctx, dest, time, gain, decay) {
  const noise = ctx.createBufferSource();
  noise.buffer = noiseBuffer(ctx, decay + 0.02);
  const hp = ctx.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 7000;
  const g = ctx.createGain();
  g.gain.setValueAtTime(gain * 0.6, time);
  g.gain.exponentialRampToValueAtTime(0.001, time + decay);
  noise.connect(hp).connect(g).connect(dest);
  noise.start(time);
  noise.stop(time + decay + 0.02);
}

export function playHat(ctx, dest, time, gain = 1) {
  hat(ctx, dest, time, gain, 0.05);
}
export function playOpenHat(ctx, dest, time, gain = 1) {
  hat(ctx, dest, time, gain, 0.3);
}

export function playClap(ctx, dest, time, gain = 1) {
  for (let i = 0; i < 3; i++) {
    const t = time + i * 0.01;
    const noise = ctx.createBufferSource();
    noise.buffer = noiseBuffer(ctx, 0.1);
    const bp = ctx.createBiquadFilter();
    bp.type = "bandpass";
    bp.frequency.value = 1200;
    const g = ctx.createGain();
    g.gain.setValueAtTime(gain * 0.5, t);
    g.gain.exponentialRampToValueAtTime(0.001, t + 0.1);
    noise.connect(bp).connect(g).connect(dest);
    noise.start(t);
    noise.stop(t + 0.1);
  }
}

export function playTom(ctx, dest, time, gain = 1) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.frequency.setValueAtTime(220, time);
  osc.frequency.exponentialRampToValueAtTime(80, time + 0.2);
  g.gain.setValueAtTime(gain, time);
  g.gain.exponentialRampToValueAtTime(0.001, time + 0.3);
  osc.connect(g).connect(dest);
  osc.start(time);
  osc.stop(time + 0.32);
}

export const DRUM_VOICES = [
  { id: "kick", label: "Kick", play: playKick, color: "#ff3333" },
  { id: "snare", label: "Snare", play: playSnare, color: "#ffb800" },
  { id: "clap", label: "Clap", play: playClap, color: "#ff007f" },
  { id: "hat", label: "Hat", play: playHat, color: "#00e5ff" },
  { id: "openhat", label: "Open Hat", play: playOpenHat, color: "#00ff66" },
  { id: "tom", label: "Tom", play: playTom, color: "#a855f7" },
];
